// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"727":"1f77bf9d","762":"ad961850","788":"cb4c1107","955":"0c547cd0"}[chunkId] + ".chunk.js";
};